import { createAction } from '@reduxjs/toolkit';

import {
  B2BTeamMember,
  B2BTeamMemberDraft,
} from '../../modules/b2b/team/types';

export const fetchB2BTeamAction = createAction('FETCH_B2B_TEAM');

export const selectB2BTeamMemberAction = createAction<{ id: string }>(
  'SELECT_B2B_TEAM_MEMBER'
);

export const createB2BTeamMemberAction = createAction<{
  id: string;
  member: B2BTeamMemberDraft;
}>('CREATE_B2B_TEAM_MEMBER');

export const updateB2BTeamMemberAction = createAction<{
  member: B2BTeamMember;
}>('UPDATE_B2B_TEAM_MEMBER');

export const deleteB2BTeamMemberAction = createAction<{ id: string }>(
  'DELETE_B2B_TEAM_MEMBER'
);
